/**
 * bookingSettingsSlice — Booking settings (Proposal + BEO).
 *
 * Hydrated from the live booking-settings API via BookingSettingsInitializer
 * (seeded server-side by `getBookingSettingsSSR()`); the forms seed their local
 * state from here and dispatch `setBookingSettings` with the server-returned
 * value on save.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  type BookingSettings,
  defaultBookingSettings,
} from "@/components/settings/booking/types";

export interface BookingSettingsState {
  settings: BookingSettings;
  loading: boolean;
}

const initialState: BookingSettingsState = {
  settings: defaultBookingSettings(),
  loading: true,
};

const bookingSettingsSlice = createSlice({
  name: "bookingSettings",
  initialState,
  reducers: {
    /** Replace the booking settings — used to hydrate from the API on mount. */
    setBookingSettings(state, action: PayloadAction<BookingSettings>) {
      state.settings = action.payload;
    },
    setBookingLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setBookingSettings, setBookingLoading } =
  bookingSettingsSlice.actions;

export default bookingSettingsSlice.reducer;
